<template>
    <div>
        <van-sticky :offset-top="0" >
            <van-icon size='22' color='#fff' style="height:46px;z-index:999;margin:15px;"  name="arrow-left" @click='back'/>
        </van-sticky>
        <!-- <div class="scanBox">
            <div style="width:200px;height:200px;border:1px solid #666;position:relative">
                <div style="position:absolute;width:15px;height:15px;border-top:5px solid #0081ff;border-left:5px solid #0081ff"></div>
                <div style="position:absolute;right:0;width:15px;height:15px;border-top:5px solid #0081ff;border-right:5px solid #0081ff"></div>
                <div style="position:absolute;bottom:0;width:15px;height:15px;border-left:5px solid #0081ff;border-bottom:5px solid #0081ff"></div>
                <div style="position:absolute;width:15px;bottom:0;right:0;height:15px;border-bottom:5px solid #0081ff;border-right:5px solid #0081ff"></div>
            </div>
            <p class='gtxt'>将二维码放入框内扫描</p>
        </div> -->
        <div id='barcode'></div>
        <div style="position:fixed;z-index:99;bottom:0;width:100%">
            <van-grid :column-num="3" :border='false' class="gridBox">
                <van-grid-item  text="二维码" style="background:rgba(0,0,0,0)!important">
                    <img src='../../assets/qr.png' width="20" alt="" srcset="">
                    <p class='gtxt' style="margin-top:10px">二维码</p>

                </van-grid-item>
                <van-grid-item  text="作物识别" style="background:rgba(0,0,0,0)!important">
                    <img src='../../assets/crop.png' width="20" alt="" srcset="">
                    <p class='gtxt'>作物识别</p>
                </van-grid-item>
                <van-grid-item  text="病虫害识别" style="background:rgba(0,0,0,0)!important">
                    <img src='../../assets/viruses.png' width="20" alt="" srcset="">
                    <p class='gtxt'>病虫害识别</p>
                </van-grid-item>
            </van-grid>
        </div>
        
        

    </div>
</template>

<script>
export default {
    name:'scan',
    data() {
        return {
            
        }
    },
    mounted() {
        this.startScan()
    },
    methods: {
        startScan(){
            let _that = this
            this.mui.plusReady( () =>{
                let barcode  = new plus.barcode.create('barcode', [plus.barcode.QR], {
                    top:'0',
                    left:'0px',
                    width: '100%',
                    height: '100%',
                    position: 'static',
                    frameColor:'#0076bf',
                    scanbarColor:'#0076bf'

		        });
                console.log(JSON.stringify(barcode)+'-this is barcode')
                barcode.onmarked = (type, code, file)=>{
                        console.log(type, code, file +'-Success')
                }
                barcode.onerror = (error)=>{
                    console.log(error+'-error')
                }		        
                plus.webview.currentWebview().append(barcode);
                barcode.start();
               
                
            })
        },
        codeSuccess(type, code, file){
            console.log(type, code, file)        
        },
        codeError(error){
            console.log(error)            
        },
        back(){
            this.$router.back(-1)
        }
    },

}
</script>


<style scoped>
.gtxt{margin-top: 8px;color: #fff;font-size: 14px;word-wrap: break-word;}
.scanBox{position:absolute;top:0;bottom:0;width:100%;background:#000;display:flex;justify-content:center;align-items:center;flex-direction:column}

</style>